var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var USPopulationConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
import { isSourceValid } from './validation/validateHelper';
export var USPopulationYear;
(function (USPopulationYear) {
    USPopulationYear["Y2010Cen"] = "2010_cen";
    USPopulationYear["Y2011Est"] = "2011_est";
    USPopulationYear["Y2012Est"] = "2012_est";
    USPopulationYear["Y2013Est"] = "2013_est";
    USPopulationYear["Y2014Est"] = "2014_est";
    USPopulationYear["Y2015Est"] = "2015_est";
    USPopulationYear["Y2016Est"] = "2016_est";
    USPopulationYear["Y2017Est"] = "2017_est";
    USPopulationYear["Y2018Est"] = "2018_est";
})(USPopulationYear || (USPopulationYear = {}));
export var USPopulationGender;
(function (USPopulationGender) {
    USPopulationGender["Male"] = "male";
    USPopulationGender["Female"] = "female";
    USPopulationGender["Total"] = "total";
})(USPopulationGender || (USPopulationGender = {}));
export var USPopulationAgeGroup;
(function (USPopulationAgeGroup) {
    USPopulationAgeGroup["G0To4"] = "0_4";
    USPopulationAgeGroup["G5To9"] = "5_9";
    USPopulationAgeGroup["G10To14"] = "10_14";
    USPopulationAgeGroup["G15To19"] = "15_19";
    USPopulationAgeGroup["G20To24"] = "20_24";
    USPopulationAgeGroup["G25To29"] = "25_29";
    USPopulationAgeGroup["G30To34"] = "30_34";
    USPopulationAgeGroup["G35To39"] = "35_39";
    USPopulationAgeGroup["G40To44"] = "40_44";
    USPopulationAgeGroup["G45To49"] = "45_49";
    USPopulationAgeGroup["G50To54"] = "50_54";
    USPopulationAgeGroup["G55To59"] = "55_59";
    USPopulationAgeGroup["G60To64"] = "60_64";
    USPopulationAgeGroup["G65To69"] = "65_69";
    USPopulationAgeGroup["G70To74"] = "70_74";
    USPopulationAgeGroup["G75To79"] = "75_79";
    USPopulationAgeGroup["G80To84"] = "80_84";
    USPopulationAgeGroup["G85"] = "85";
    USPopulationAgeGroup["Total"] = "total";
})(USPopulationAgeGroup || (USPopulationAgeGroup = {}));
const schema = {
    $id: 'urn:wisepipe-common-pipe:USPopulationConfig',
    type: 'object',
    properties: {
        countyColumn: { type: 'string', minLength: 1 },
        stateColumn: { type: 'string', minLength: 1 },
        year: { type: 'string', enum: Object.values(USPopulationYear) },
        genders: {
            type: 'array',
            items: { type: 'string', enum: Object.values(USPopulationGender) },
            minItems: 1,
            uniqueItems: true
        },
        ageGroups: {
            type: 'array',
            items: { type: 'string', enum: Object.values(USPopulationAgeGroup) },
            minItems: 1,
            uniqueItems: true
        }
    },
    required: ['stateColumn', 'year', 'genders', 'ageGroups']
};
let USPopulationConfig = USPopulationConfig_1 = class USPopulationConfig extends ToolConfig {
    constructor(stateColumn, year, genders, ageGroups, countyColumn, customFormats) {
        super(ToolType.US_POPULATION, customFormats);
        if (countyColumn !== undefined)
            this.countyColumn = countyColumn;
        this.stateColumn = stateColumn;
        this.year = year;
        this.genders = genders;
        this.ageGroups = ageGroups;
        JSON.validate(this, USPopulationConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return USPopulationConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return USPopulationConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return USPopulationConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return USPopulationConfig_1.outs;
    }
    static get in() {
        return USPopulationConfig_1.ins[0];
    }
    static get out() {
        return USPopulationConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo('US Population', [ToolCategories.DATA], this.ins, this.outs, ['demographic', 'age', 'gender'], true);
    }
    static getOutputColumn(gender, ageGroup) {
        let ageGroupName;
        if (ageGroup === USPopulationAgeGroup.Total) {
            ageGroupName = ageGroup.charAt(0).toUpperCase() + ageGroup.slice(1);
        }
        else if (ageGroup === USPopulationAgeGroup.G85) {
            ageGroupName = `${ageGroup}+`;
        }
        else {
            const ageGroupParts = ageGroup.split('_');
            ageGroupName = `${ageGroupParts[0]}-${ageGroupParts[1]}`;
        }
        if (gender === USPopulationGender.Total) {
            return ageGroupName;
        }
        return `${gender.charAt(0).toUpperCase()}${gender.slice(1)} ${ageGroupName}`;
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        const exp = tsb.export(this.out);
        if (source) {
            const requiredCols = [this.stateColumn];
            if (this.countyColumn)
                requiredCols.push(this.countyColumn);
            const dependents = this.copyAllInsAndReturnDependents(exp, this.in, source, requiredCols);
            this.genders.forEach((gender) => {
                this.ageGroups.forEach((ageGroup) => {
                    exp.makeNew(new Column(USPopulationConfig_1.getOutputColumn(gender, ageGroup), 'number'), dependents, true);
                });
            });
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationState.BAD_METADATA;
        }
        const inputs = new Map([[this.stateColumn, ['string']]]);
        if (this.countyColumn !== undefined) {
            inputs.set(this.countyColumn, ['string']);
        }
        const outputs = [];
        this.genders.forEach((gender) => {
            this.ageGroups.forEach((ageGroup) => {
                outputs.push(USPopulationConfig_1.getOutputColumn(gender, ageGroup));
            });
        });
        return isSourceValid(source, inputs, outputs) ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
    }
};
USPopulationConfig = USPopulationConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.US_POPULATION)
], USPopulationConfig);
export { USPopulationConfig };
//# sourceMappingURL=usPopulationConfig.js.map